<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column"></h3>
          <div class="card-toolbar">
            <b-button
              variant="primary"
              class="float-right"
              style="padding-top: 6px; padding-bottom: 6px"
              v-on:click.prevent="$router.push('company-management/form')"
            >
              {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
            </b-button>
          </div>
        </div>
        <div class="card-body pt-0 pb-3">
          <div class="col-lg-6 p-0">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input
                  v-model="pagination.filter"
                  :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
                  type="search"
                  id="filterInput"
                  debounce="500"
                  @update="fetchData()"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="!pagination.filter"
                    @click="
                      pagination.filter = '';
                      fetchData();
                    "
                    >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="tab-content">
            <div class="table-responsive">
              <b-table
                id="organizations-table"
                :striped="false"
                :items="items"
                :fields="fields"
                :sort-by.sync="pagination.orderBy"
                :sort-desc.sync="pagination.isDesc"
                :no-sort-reset="true"
                :busy.sync="isBusy"
                :loading="false"
                :borderless="true"
                head-variant="light"
                :no-local-sorting="true"
                @sort-changed="sortChange"
              >
                <template #cell(id)="data">
                  <div class="text-right">
                    <span v-if="pagination.isDesc">{{
                      total - (pagination.perPage * (pagination.page - 1) + data.index)
                    }}</span>
                    <span v-if="!pagination.isDesc">
                      {{ pagination.perPage * (pagination.page - 1) + data.index + 1 }}
                    </span>
                  </div>
                </template>

                <template #cell(name)="data">
                  <div class="d-flex align-items-center">
                    {{ data.value }}
                  </div>
                </template>

                <template #cell(plan_display)="data">
                  <span class="text-nowrap">{{ data.item.plan_display || "—" }}</span>
                </template>

                <template #cell()="data">
                  <div class="d-flex align-items-center">
                    {{ data.value }}
                  </div>
                </template>

                <template #cell(switch)="data">
                  <toggle-button
                    :value="data.item.status_id === 1"
                    :sync="true"
                    color="#1BC5BD"
                    @change="updateStatus($event, data.item.id)"
                  ></toggle-button>
                </template>

                <template #cell(action)="data">
                  <div class="text-nowrap">
                    <a
                      href="javascript:"
                      @click.prevent="
                        $router.push(`company-management/form/${data.item.id}`)
                      "
                      class="btn btn-icon btn-light btn-sm"
                      :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-success">
                        <inline-svg src="media/svg/icons/General/Edit.svg"></inline-svg>
                      </span>
                    </a>
                    &nbsp;
                    <a
                      href="javascript:"
                      @click.prevent="
                        $router.push(`company-management/${data.item.id}/campaign`)
                      "
                      class="btn btn-icon btn-light btn-sm"
                      v-b-tooltip.hover
                      :title="$t('MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN')"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-primary">
                        <inline-svg src="media/svg/icons/Shopping/Gift.svg"></inline-svg>
                      </span>
                    </a>
                    <template
                      v-if="Number(data.item.is_member_tier_enabled) === 1"
                    >
                      &nbsp;
                      <a
                        href="javascript:"
                        @click.prevent="
                          $router.push(
                            `company-management/${data.item.id}/member-tier`
                          )
                        "
                        class="btn btn-icon btn-light btn-sm"
                        v-b-tooltip.hover
                        title="ระดับสมาชิก"
                      >
                        <i class="flaticon-medal text-primary"></i>
                      </a>
                    </template>
                  </div>
                </template>
              </b-table>
              <p class="text-center pt-3" v-if="items.length < 1">
                {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
              </p>
            </div>
            <div class="row justify-content-between">
              <div div class="col-lg-2">
                <b-form-group
                  id="name-input-group"
                  :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
                  label-for="name-input"
                  label-cols="7"
                  label-align-sm="left"
                  label-size="lg"
                >
                  <b-form-select
                    v-model="pagination.perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="paginationOptions"
                    @change="fetchData()"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div div class="col-lg-2">
                <b-pagination
                  v-model="pagination.page"
                  :total-rows="total"
                  :per-page="pagination.perPage"
                  @input="fetchData()"
                  align="right"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.idField {
  min-width: 100px;
  width: 100px;
  max-width: 100px;
}
.actionField {
  min-width: 140px !important;
  width: 140px !important;
  max-width: 140px !important;
}
.switchField {
  min-width: 100px;
  width: 100px;
  max-width: 100px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import {
  PAGINATION_COMPANY_MANAGEMENT_DATA,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION,
  PUT_COMPANY_MANAGEMENT_STATUS_DATA,
} from "@/core/services/store/company_management.module";

export default {
  data() {
    return {
      fields: [
        {
          key: "id",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          key_table: "company.id",
          sortable: true,
          isFilter: false,
          tdClass: "idField",
        },
        {
          key: "name",
          label: `${this.$t("PAGE.COMPANY_MANAGEMENT.TABLE.FIELDS.NAME")}`,
          key_table: "name",
          sortable: true,
          isFilter: true,
        },
        {
          key: "plan_display",
          label: `${this.$t("PAGE.COMPANY_MANAGEMENT.TABLE.FIELDS.PLAN")}`,
          sortable: false,
          isFilter: false,
        },
        {
          key: "switch",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.SWITCH")}`,
          sortable: false,
          isFilter: false,
          tdClass: "switchField",
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField",
        },
      ],
      select: ["id", "name", "status_id", "is_member_tier_enabled"],
      include: [],
      paginationOptions: [25, 50, 100, 200],
      isBusy: false,
      items: [],
      total: 0,
    };
  },
  computed: {
    isClearPagination: {
      get() {
        return this.$store.state.company_management.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value,
        });
      },
    },
    pagination: {
      get() {
        return this.$store.state.company_management.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      },
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}` },
    ]);
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }
    this.isClearPagination = true;
    this.fetchData();
  },
  methods: {
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    getParams() {
      const orderByIndex = this.fields.findIndex(
        (item) => item.key === this.pagination.orderBy.toString()
      );
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        orderBy: orderByIndex ? this.fields[orderByIndex].key_table : "id",
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        filterBy: `${this.fields
          .map((item) => {
            if (item.isFilter) return item.key;
          })
          .filter((item) => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`,
      };
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_COMPANY_MANAGEMENT_DATA, {
          params: this.getParams(),
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
          });
          this.isBusy = false;
        });
    },
    updateStatus(event, id) {
      this.isBusy = true;
      this.$store
        .dispatch(PUT_COMPANY_MANAGEMENT_STATUS_DATA, {
          id,
          data: {
            status_id: event.value ? 1 : 2,
          },
        })
        .then(({ data }) => {
          if (data.status === "success") {
            Swal.fire({
              icon: "success",
              text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            });
            setTimeout(() => {
              this.fetchData();
            }, 500);
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
          });
          this.isBusy = false;
        });
    },
  },
};
</script>
